/**
 * Default shadow resolution.
 */
export enum ShadowResolution {
  /** Low shadow map resolution. */
  Low,
  /** Medium shadow map resolution. */
  Medium,
  /**  High shadow map resolution. */
  High,
  /** Very high shadow map resolution. */
  VeryHigh
}
